/*
 * @deprecated
 * **/

import {
  Checkbox,
  Divider,
  Popover,
  Select,
  Table,
  TableColumnsType,
  Tooltip,
} from "antd";
// import { ColumnType } from "antd/es/list";
import { useState } from "react";
import {
  BsArrowDownShort,
  BsArrowUpShort,
  BsEraserFill,
  BsFilterRight,
} from "react-icons/bs";
import { AnyObject } from "yup";
import Actions from "../Actions/Actions";
import { ActionsKey } from "../../models/Actions";
import { ColumnItem } from "../../models/table";
import { Form } from "react-bootstrap";
import useAppStore from "../../../store/AppStore";
import { userHasAuthorization } from "../../../utilities/helpers/permissions";

// type ColumnOfTable = {
//   key: string;
//   label: string;
// }

type LFTableProps = {
  columns: ColumnItem[];
  data: AnyObject[];
  onChangeColumns: (cols: ColumnItem[]) => void;
  permissions: Array<ActionsKey>;
  onAction: (item: any, action: ActionsKey) => void;
  exceptions?: Record<ActionsKey, { key: string; value: string } | null>;
  onSearch?: (search: { searchStr: string; dataKey: string }) => void;
  sort?: { dataKey: string; order?: "asc" | "desc" } | null;
  onSort?: (order: { dataKey: string; order?: "asc" | "desc" } | null) => void;
  onResetSearch?: () => void;
  options?: any; // {dataKey: any[]} | null,
};

const LFTable = ({
  columns,
  data,
  onChangeColumns,
  permissions,
  onAction,
  exceptions,
  onSearch,
  sort,
  onSort,
  onResetSearch,
  options,
}: LFTableProps) => {
  const [openCol, setOpenCol] = useState<boolean>(false);
  const { authorizationData } = useAppStore();
  const searchRefs: any[] = [];
  const handleOpenChange = (newOpen: boolean) => {
    setOpenCol(newOpen);
  };
  const col2show: TableColumnsType<AnyObject> = [
    {
      key: "",
      title: () => {
        return (
          <div>
            <div
              style={{ height: 31 }}
              className="p-1 d-flex justify-content-end px-3"
            >
              <Tooltip title={"Effacer"}>
                <div
                  className="cursor-pointer "
                  onClick={() => {
                    console.log("searchRefs : ", searchRefs);
                    searchRefs?.forEach((input) => {
                      if (input && input?.current) {
                        input.current.value = "";
                      } else if (input && input?.value) {
                        input.value = "";
                      }
                    });
                    if (onResetSearch) {
                      onResetSearch();
                    }
                  }}
                >
                  <BsEraserFill size={20} />
                </div>
              </Tooltip>
            </div>
            <div className="d-flex align-items-center justify-content-between p-3 w-100">
              <div>Actions</div>
              <Tooltip title={"Afficher/Cacher"}>
                <Popover
                  open={openCol}
                  trigger={"click"}
                  placement="bottomLeft"
                  onOpenChange={handleOpenChange}
                  content={() => {
                    let allChecked: boolean = true;
                    columns.forEach((cd) => {
                      if (!cd?.show) {
                        allChecked = false;
                      }
                    });
                    return (
                      <div>
                        <div>
                          <div>
                            <Checkbox
                              checked={allChecked}
                              onChange={(e) => {
                                let newCols = [...columns];
                                if (allChecked) {
                                  newCols.forEach((ne, ie) => {
                                    newCols[ie].show = false;
                                  });
                                } else {
                                  newCols.forEach((ne, ie) => {
                                    newCols[ie].show = true;
                                  });
                                }
                                onChangeColumns(newCols);
                              }}
                            />
                            <span className="ms-2">Tout</span>
                          </div>
                        </div>
                        <Divider className="my-2" />
                        {columns?.map((cop, ik) => {
                          return (
                            <div className="d-flex">
                              <Checkbox
                                checked={cop?.show}
                                onChange={(e) => {
                                  let newCols = [...columns];
                                  newCols[ik].show = !columns[ik].show;
                                  onChangeColumns(newCols);
                                }}
                              />
                              <span className="ms-2">{cop?.title}</span>
                            </div>
                          );
                        })}
                      </div>
                    );
                  }}
                >
                  <div
                    className="p-0 cursor-pointer"
                    // onClick={() => setOpenCol(true)}
                  >
                    <BsFilterRight size={20} />
                  </div>
                </Popover>
              </Tooltip>
            </div>
          </div>
        );
      },
      render: (role) => {
        let perms: ActionsKey[] = [];
        permissions?.forEach((pe, i) => {
          if (role?.userRole?.isRequired && pe === "read") {
            perms.push(pe);
          } else {
            perms.push(pe);
          }
          // if (!exceptions) {
          //   perms = permissions;
          // } else if (exceptions[pe]) {
          //   const objectKeys = exceptions[pe]?.key?.split(".");
          //   let theNested: any = null;
          //   objectKeys?.forEach((k, p) => {
          //     if (p === 0) {
          //       theNested = role[k];
          //     } else if (p > 0 && theNested === null) {
          //       perms.push(pe);
          //     } else {
          //       console.log('theNested and k', k)
          //       // if (p <= objectKeys?.length - 1) {
          //       // theNested = theNested[k];
          //       // }
          //       // else {}
          //     }
          //   });
          //   if (theNested && theNested !== exceptions[pe]?.value) {
          //     perms.push(pe);
          //   }
          // } else {
          //   perms.push(pe);
          // }
        });
        return (
          <div>
            <Actions
              permissions={perms}
              onViewDetailClick={() => {
                onAction(role, "read");
              }}
              onUpdateClick={() => {
                onAction(role, "update");
              }}
              onDeleteClick={() => {
                onAction(role, "delete");
              }}
            />
          </div>
        );
      },
      fixed: true,
      width: 150,
    },
  ];
  columns.forEach((col) => {
    if (col?.show) {
      col2show.push({
        ...col,
        title: (_) => {
          return (
            <div
              className="d-flex flex-column align-items-center"
              onClick={() => {
                if (!sort && onSort) {
                  onSort({
                    dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                    order: "desc",
                  });
                } else if (sort && sort?.dataKey !== col?.dataIndex && onSort) {
                  onSort({
                    dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                    order: "desc",
                  });
                } else if (sort?.order === "asc" && onSort) {
                  onSort(null);
                } else if (sort?.order === "desc" && onSort) {
                  onSort({
                    dataKey: col.dataIndex ?? col?.nestedKey ?? "",
                    order: "asc",
                  });
                }
              }}
            >
              <div className="w-100 p-1">
                {(!col?.searchType || col?.searchType === "text") && (
                  <Form.Control
                    ref={(ref: any) => {
                      searchRefs.push(ref);
                    }}
                    size="sm"
                    type="text"
                    onChange={(e) => {
                      const theText = e.target.value?.trim();
                      // replaceAll(/\s/g, '')
                      if (theText?.length <= 2 && theText?.length > 0) {
                        console.log("White space detected ");
                        return;
                      }
                      if (e.target.value?.length >= 3 && onSearch) {
                        let theKeyUse = "";
                        if (col?.nestedKey) {
                          let arr = col?.nestedKey?.split(".");
                          arr?.forEach((nest, ic) => {
                            if (ic === 0) {
                              theKeyUse += nest;
                            } else {
                              theKeyUse += "[" + nest + "]";
                            }
                          });
                        } else {
                          theKeyUse = col?.dataIndex;
                        }
                        onSearch({
                          dataKey: theKeyUse,
                          searchStr: e.target.value,
                        });
                      } else if (e.target.value?.length === 0 && onSearch) {
                        onSearch({
                          dataKey: col?.nestedKey ?? col?.dataIndex,
                          searchStr: "",
                        });
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                )}
                {col?.searchType === "select" &&
                  options !== null &&
                  options !== undefined && (
                    <Select
                      className="w-100 "
                      style={{ height: 31 }}
                      size="large"
                      options={options[col?.dataIndex] ?? []}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      // value={actioned?.data?.userRole?.["@id"]}
                      // disabled={actioned?.action === "read"}
                      // defaultValue={actioned?.data?.userRole?.["@id"] ?? null}
                      showSearch
                      onChange={(v) => {
                        // roleForm.setFieldValue("userRole", v ?? "");
                        let theKeyUse = col?.nestedKey ?? col?.dataIndex ?? "";
                        // if (col?.nestedKey) {
                        //   let arr = col?.nestedKey?.split('.')
                        //   arr?.forEach((nest, ic) => {
                        //     if (ic === 0) {
                        //       theKeyUse += nest;
                        //     } else {
                        //       theKeyUse += '[' + nest + ']'
                        //     }
                        //   })
                        // } else {
                        //   theKeyUse = col?.dataIndex
                        // }
                        if (v && onSearch) {
                          onSearch({
                            dataKey: theKeyUse,
                            searchStr: v?.substring(v?.split("/")[2]),
                          });
                        }
                      }}
                      // filterOption={(input, apt) => {
                      //   if (apt) {
                      //     return (
                      //       apt.label?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                      //         0 ||
                      //       apt.label?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
                      //     );
                      //   }
                      //   return false;
                      // }}
                    />
                  )}
              </div>
              <div className="p-3 table-title text-center w-100 h-100 d-flex align-items-center justify-content-center">
                <span>{col?.title}</span>
                <div>
                  {sort?.order === "asc" &&
                    sort?.dataKey === (col?.nestedKey ?? col?.dataIndex) && (
                      <BsArrowUpShort />
                    )}
                  {sort?.order === "desc" &&
                    sort?.dataKey === (col?.nestedKey ?? col?.dataIndex) && (
                      <BsArrowDownShort />
                    )}
                </div>
              </div>
            </div>
          );
        },
      });
    }
  });
  return (
    <div>
      <Table
        columns={col2show}
        dataSource={data}
        className=""
        rowClassName={(r, i) => {
          return i % 2 === 0
            ? "text-center  table-row-c2"
            : "text-center  table-row-c1";
        }}
        locale={{
          emptyText: "Aucune donnée",
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default LFTable;
